import { get, find, includes } from 'lodash';

export const isLoadingArticle = (state, articleId) => {
  const articles = get(state, 'sponsoredContent.loadingArticles', []);
  return includes(articles, articleId);
};

export const isLoadingArticles = (state) => {
  const loadingArticles = get(state, 'sponsoredContent.loadingArticles', []);
  return loadingArticles.length > 0;
};

export const hasLoadedArticle = (state, articleId) => {
  const events = get(state, 'sponsoredContent.loadedArticles', []);
  return includes(events, articleId);
};

export const hasAttemptedArticleLoad = (state, articleId) => {
  const articles = get(state, 'sponsoredContent.hasAttemptedLoad', []);
  return includes(articles, articleId);
};

export const getArticle = (state, articleId) => {
  const articles = get(state, 'sponsoredContent.articles', []);
  return find(articles, { id: articleId }) || {};
};

export const getSponsoredPageLoadingError = (state, contentId) => {
  const errors = get(state, `sponsoredContent.sponsoredArticlePageLoadingError`);
  const error = get(errors, contentId, false);

  return error;
};

export const getSponsoredArticlePageLoadingError = (state) =>
  get(state, 'sponsoredContent.newsArticlePageLoadingError');
